import React, { useState } from 'react';

import chapterImg1 from '../../../../assets/images/courses/team-players/chapter4.1.1.jpg';
import chapterImg2 from '../../../../assets/images/courses/team-players/chapter4.1.2.jpg';
import { CourseChapter } from '../../../../courses/courses.types';
import { JigSawModule } from '../../JigSawModule';

interface TeamPlayersProps {
  chapter: CourseChapter;
  onNextChapter: (nextIndex: number) => void;
  totalPages: number;
  courseId?: string;
  onQuizResult?: (result: boolean | undefined) => void;
}

export const TeamPlayersChapter4: React.FC<TeamPlayersProps> = ({
  chapter,
  onNextChapter,
  totalPages,
}) => {
  const [selectedSkill, setSelectedSkill] = useState('');

  const handleNextChapterClick = () => {
    onNextChapter(chapter.index + 1);
  };
  const handleOptionChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedSkill(event.target.value);
  };
  const handlePrint = (view: string) => {
    const printArea = document.getElementById(view);
    if (printArea) {
      printArea.classList.add('print-view');

      const cleanup = () => {
        printArea.classList.remove('print-view');
        window.onafterprint = null;
      };

      window.onafterprint = cleanup;

      window.print();
    }
  };
  const boxes = [
    {
      id: '1',
      title: 'Shared Vision',
      content:
        'A shared vision is crucial for any team because it gives everyone a common goal to work towards. When team members have a clear understanding of what they are trying to achieve, they are more motivated and focused. This shared vision helps align individual efforts, ensuring that everyone is on the same page and working in harmony. It also fosters a sense of unity and purpose, making team members feel like they are part of something bigger than themselves. With a shared vision, teams can make better decisions, as everyone knows the goal and can prioritize tasks accordingly. It also encourages collaboration and innovation, as team members are inspired to contribute their best ideas and efforts to achieve the common objective. In essence, a shared vision not only guides a team´s actions but also strengthens their bond, making them more resilient and capable of overcoming challenges together. Think about a team you are on and ask yourself: Do you know where your team is headed? Have you talked to the team lead about the team´s vision? And do you have any ideas for where the team should go next?',
      color: '#7b6bd8', //green
    },
    {
      id: '2',
      title: 'Reliable',
      content:
        'A shared vision is crucial for any team because it gives everyone a common goal to work towards. When team members have a clear understanding of what they are trying to achieve, they are more motivated and focused. This shared vision helps align individual efforts, ensuring that everyone is on the same page and working in harmony. It also fosters a sense of unity and purpose, making team members feel like they are part of something bigger than themselves. With a shared vision, teams can make better decisions, as everyone knows the goal and can prioritize tasks accordingly. It also encourages collaboration and innovation, as team members are inspired to contribute their best ideas and efforts to achieve the common objective. Inessence, a shared vision not only guides a team´s actions but also strengthens their bond, making them more resilient and capable of overcoming challenges together. Think about a team you are on and ask yourself: Do you know where your team is headed? Have you talked to the team lead about the team´s vision? And do you have any ideas for where the team should go next?',
      color: '#7b6bd8', //green
    },
    {
      id: '3',
      title: 'Positive Attitude',
      content:
        'Imagine if top soccer teams like Brazil or Germany stepped onto the field looking defeated and murmuring, "We´ll probably lose anyway, let´s just get it over with." They wouldn´t stand a chance, right? This kind of attitude isn´t helpful for any team. Having a positive attitude is super important in teamwork. When everyone stays positive, it creates a supportive and encouraging environment where people feel motivated to do their best. This positivity helps build a sense of togetherness, making it more fun and effective to work together. A positive attitude also helps the team solve problems better. Instead of getting stuck on difficulties, optimistic team members focus on finding solutions and new ideas. This way of thinking helps the team handle challenges with confidence and creativity. Positivity is also contagious. When one person has a good attitude, it often spreads to others, lifting everyone´s spirits. This leads to better communication because people feel more comfortable sharing their ideas in a friendly atmosphere. It also helps reduce stress and conflicts, as a positive approach encourages understanding and cooperation instead of blame and negativity. In short, having a positive attitude is key to making a team successful. It boosts everyone´s mood, improves problem-solving, encourages teamwork, and makes the work environment more enjoyable and productive. By staying positive, teams can reach their goals more easily and have a great time doing it.',
      color: '#7b6bd8', //green
    },
    {
      id: '4',
      title: 'Right Amount of Talking',
      content:
        'The ideal team player strikes a balance between speaking up and listening, ensuring they contribute without dominating the conversation. They´re mindful not to monopolize too much of the discussion, aiming for a healthy 10% of the airtime, with the remaining 90% left for others to share their thoughts. So, if you tend to be on the talkative side, challenge yourself to stick to this ratio in meetings or group settings. Probing questions: The ideal team player strikes a balance between speaking up and listening, ensuring they contribute without dominating the conversation. They´re mindful not to monopolize too much of the discussion, aiming for a healthy 10% of the airtime, with the remaining 90% left for others to share their thoughts. So, if you tend to be on the talkative side, challenge yourself to stick to this ratio in meetings or group settings.',
      color: '#7b6bd8', //green
    },
    {
      id: '5',
      title: 'Flexibility in Roles',
      content:
        'Within a small team of two or three members, everyone needs to wear multiple hats and contribute in various ways. Simply sticking to one role isn´t sufficient. Even if your top skill is meticulous attention to detail, someone else might excel in the same area. Therefore, you may not always get to utilize your primary strength. Flexibility in roles is a crucial quality for a team player, and it´s worthconsciously developing this trait in yourself. Start by identifying your core strengths, but also consider your backup options. You may have one, two, or even three other skills that you can bring to the team. You´ll then be ready to deploy these secondary choices if needed. It´s a deliberate decision-making process. For instance, you might enjoy taking charge, but if someone else is better suited for leadership, you´re willing to step back and take on a different role. It´s not always easy, but it´s necessary for effective teamwork. For example, you might need to relinquish leadership, even if it´s your preferred role, or step up to it, even if it´s not your first choice, simply because no one else is available to take on the responsibility.  Consider your own flexibility. Do you always gravitate towards a favorite role in every team task? And what are your backup roles that you could readily step into? To assist you in this reflection, there´s a list of potential team roles available in the exercise files that you can download and contemplate.',
      color: '#7b6bd8', //green
    },
    {
      id: '6',
      title: 'Going the Extra Mile',
      content:
        'A great team player goes the extra mile, to deliver more than promised. This might mean doing something that´s great for the team but costs you a little, and that´s really the essence of teamwork. If someone isn´t willing to give a little extra for the team´s sake, they probably shouldn´t be on the team. Going above and beyond what you´ve promised is what sets apart the top performers and the best companies. It´s a mindset you should adopt in all aspects of your life. Just meeting the basic requirements isn´t sufficient. The goal is to keep getting better, exceeding expectations every time, and doing more than what others anticipate. If you´ve got to be there anyway, you might as well do the best you can and be proud of what you do. Do it for yourself, as well as for the team. Strive to get better! Reflect: Thinking about yourself as a team player, how often do you go that extra mile? What did you do today that was better than it needed to be and better than people expected? In what areas of your team role could you really excel?',
      color: '#7b6bd8', //green
    },
  ];

  return (
    <>
      <div className="content-wrap lg:border-l lg:pl-8 lg:pt-8 pt-4 pb-10">
        <p className="text-sm italic  mb-7">
          Part {chapter.index} of {totalPages}
        </p>
        <h2 className="font-semibold text-3xl">Characteristics of a Great Team</h2>
        <br />
        <h3 className="text-2xl text-purple-600 font-bold mt-10 mb-1">
          What Makes a Great Team Player?
        </h3>
        <div className="md:flex items-center mt-10 mb-10">
          <p className="flex-1 leading-7">
            <br />
            Co-workers who collaborate make a good team. A family that collaborates makes <br /> a
            good team. Friends who collaborate make a <br /> good team. A good team needs all kinds
            of people.
          </p>
          <div className="md:mr-8 max-w-full md:max-w-xs w-full mb-5 md:mb-0">
            <img src={chapterImg1} alt="" />
          </div>
        </div>
        <h3 className="text-2xl text-purple-600 font-bold mb-5">Did you know…</h3>
        <br />
        <p className="text-xl text-left font-light mt-10 mb-10">
          When researchers at Carnegie Mellon, M.I.T. and Union College studied teams they noticed
          two behaviors that all the good teams generally shared.
        </p>
        <ul className="list-decimal pl-5 mb-14 text-xl font-light">
          <li className="pl-9 mb-7">
            On the good teams, by the end of the day, everyone had spoken roughly the same amount.
            ‘‘As long as everyone got a chance to talk, the team did well,’’ but if only one person
            or a small group spoke all the time, the collective intelligence declined.’’
          </li>
          <li className="pl-9 mb-7">
            The good teams all had high ‘‘average social sensitivity’’. That’s a fancy way of saying
            they were skilled at understanding how others felt, based on their tone of voice, their
            expressions, and other nonverbal cues.
          </li>
        </ul>
        <br />
        <h2 className="font-normal text-center text-3xl">
          A great team is made up of qualities that help everyone work well together and reach their
          goals. These qualities include good communication, trust, different skills, and a shared
          purpose.{' '}
        </h2>
        <div className="md:flex items-center mt-10 mb-10">
          <p className="flex-1 leading-9">
            <br />
            <br />
            In a strong team, everyone knows their role and contributes, making it easier to share
            ideas and solve problems together.
            <br />
            Team members respect each other and are committed to the team's success, which keeps
            everyone motivated and involved. By having these characteristics, a great team can
            overcome challenges, come up with new ideas, and achieve amazing things together.
          </p>
          <div className="md:mr-8 max-w-full md:max-w-xs w-full mb-5 md:mb-0">
            <img src={chapterImg2} alt="" />
          </div>
        </div>
        <h3 className="text-2xl text-purple-600 font-bold mt-10 m-5">Reflect</h3>
        <p className="text-lg font-bold flex-1 mt-5 mb-5">
          Reflect and answer the question below. You may print your response upon completion.
        </p>
        <div id="print-view1" className="bg-gray-200 p-4 rounded-lg">
          <p className="text-xl font-light flex-1 mt-5 mb-5">
            Choose one collaboration skill from the following list and answer the question:
          </p>

          <ol className="list-decimal pl-5 mb-14 text-xl font-light">
            {[
              'Being creative',
              'Communicating well',
              'Being patient',
              'Working hard',
              'Being organized',
              'Bringing other people together',
            ].map((skill) => (
              <li key={skill} className="pl-9 mb-7 flex items-center">
                <input
                  type="radio"
                  name="collaborationSkill"
                  value={skill}
                  checked={selectedSkill === skill}
                  onChange={handleOptionChange}
                  className="mr-3 w-6 h-6 cursor-pointer"
                />
                {skill}
              </li>
            ))}
          </ol>

          <p className="text-xl font-light flex-1 mt-5 mb-5">
            How would the skill you choose be important on a team?
          </p>

          <textarea
            className="w-full bg-purple-300 h-32 p-2 border rounded"
            placeholder="Enter your text here..."
          ></textarea>

          <div className="mt-5 text-right">
            <button onClick={() => handlePrint('print-view1')} className="btn-internal">
              PRINT
            </button>
          </div>
        </div>
        <h3 className="text-2xl text-center font-normal mt-10 mb-5">
          Let’s look at some common behaviors and characteristics in more detail. Click continue
          below.
        </h3>
        <h3 className="text-2xl text-purple-600  font-bold mt-10 mb-5">
          Common Behaviors & Characteristics
        </h3>
        <h3 className="text-2xl text-center font-normal mt-10 mb-5">
          Great teams don't just happen; they are built on shared vision, reliability, positive
          attitudes, balanced communication, role flexibility, and a commitment to go the extra
          mile.
        </h3>
        <h4 className="text-lg text-left mt-7 mb-20 font-bold">Click below to play the video.</h4>
        <div className="video-wrap mt-8 mb-12">
          <video className="rounded-3xl" controls controlsList="nodownload">
            <source
              src={chapter?.course_video_url && chapter?.course_video_url[0]}
              type="video/mp4"
            />
          </video>
        </div>
        {/* media pending */}
        <br />
        <p className="text-xl font-light flex-1 mt-5 mb-5">
          For more information on the common behaviors and characteristics click on each tab below.
        </p>
        <JigSawModule backgroundColor="#f3f4f6" boxes={boxes} />

        <h3 className="text-2xl text-purple-600 font-bold mt-10 m-5">Reflect</h3>
        <div id="print-view2">
          <p className="text-lg font-bold flex-1 mt-5 mb-5">
            Reflect and answer the question below. You may print your response upon completion.
          </p>
          <ol className="list-decimal pl-7 mb-14 text-xl font-light">
            <li>
              <p className="text-xl font-light flex-1 mt-5 mb-5">
                Thinking about yourself as a team player, how often do you go extra mile?
              </p>

              <textarea
                className="w-full  h-32 p-2 border rounded"
                placeholder="Enter your text here..."
              ></textarea>
            </li>
            <li>
              <p className="text-xl font-light flex-1 mt-5 mb-5">
                What did yo do today that was better than it needed to be and better then people
                expected?
              </p>

              <textarea
                className="w-full  h-32 p-2 border rounded"
                placeholder="Enter your text here..."
              ></textarea>
            </li>
            <li>
              <p className="text-xl font-light flex-1 mt-5 mb-5">
                In what areas of your team role could you really excel?
              </p>

              <textarea
                className="w-full  h-32 p-2 border rounded"
                placeholder="Enter your text here..."
              ></textarea>
            </li>
          </ol>

          <div className="mt-5 text-right">
            <button onClick={() => handlePrint('print-view2')} className="btn-internal">
              PRINT
            </button>
          </div>
        </div>

        <h3 className="text-2xl mt-2  text-center font-light mb-5">
          Next, assessing & using your teamwork strengths.
        </h3>
        <br />
        <button onClick={handleNextChapterClick} className="btn-internal w-full">
          Assessing & Using Your Teamwork Strengths
        </button>
      </div>
    </>
  );
};
